/** Encode browse-filter selection for MULTI_ENUM (comma-separated option keys). */
export function encodeMultiEnumFilter(selected: string[]): string {
  return selected.map(key => `${key}`.trim()).filter(Boolean).join(',');
}

/** Decode browse-filter value back to selected option keys. */
export function decodeMultiEnumFilter(raw: string | null | undefined): string[] {
  if (!raw) {
    return [];
  }
  const trimmed = `${raw}`.trim();
  if (!trimmed) {
    return [];
  }
  if (trimmed.startsWith('[')) {
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.map(v => `${v}`.trim()).filter(Boolean);
      }
    } catch {
      // fall through to comma split
    }
  }
  return trimmed.split(',').map(v => v.trim()).filter(Boolean);
}
